import React from "react";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpArrowDown, faMinus } from "@fortawesome/pro-regular-svg-icons";

import { ButtonNew as Button } from "components/buttonNew";

interface IProps {
  onAdjustBalance: () => void;
  adjustDisabled?: boolean;
}

export default function CustomerCreditEmptyState(props: IProps) {
  const { onAdjustBalance, adjustDisabled } = props;
  const { t } = useTranslation();

  return (
    <div className="customer-credit-empty-state">
      <div className="customer-credit-empty-state__icon">
        <FontAwesomeIcon icon={faMinus} />
      </div>
      <h4 className="customer-credit-empty-state__title">{t("No transactions yet")}</h4>
      <p className="customer-credit-empty-state__description">
        {t(
          "This credit book was recently created. Transactions will appear here as credits are earned or adjustments are made.",
        )}
      </p>
      <Button type="primary" size="medium" disabled={adjustDisabled} onClick={onAdjustBalance}>
        <FontAwesomeIcon icon={faArrowUpArrowDown} className="mr-2" />
        {t("Adjust credit balance")}
      </Button>
    </div>
  );
}
